//basic
import React, { Component } from 'react'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'

//style
import './IssueCards.scss'

//api
import { api } from '../../functions/api'

//custom components
import Search from '../../components/basic/search'
import CustomButton from '../../components/basic/CustomButton'
import CustomTable from '../../components/complex/customTable'

//material-ui
import {
  CircularProgress,
  createMuiTheme,
  MuiThemeProvider,
  Grid,
} from '@material-ui/core'

//other libraries
import queryString from 'query-string'
import Icon from '@mdi/react'
import { mdiCloudUpload } from '@mdi/js'

import 'moment/locale/sk'
import { debounce } from 'lodash/function'
import Import from './import'

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiInput: {
      formControl: {
        minWidth: '170px',
      },
      underline: {
        '&:after': {
          borderBottomColor: 'rgba(0, 0, 0, 0.54) !important',
        },
      },
    },
    MuiFormLabel: {
      root: {
        color: 'rgba(0, 0, 0, 0.54) !important',
      },
      focused: {
        color: 'rgba(0, 0, 0, 0.54) !important',
      },
    },
    MuiFormControl: {
      root: {
        marginLeft: '5px',
        bottom: '8px',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#FF7800',
      },
      thumb: {
        backgroundColor: '#FF7800',
        borderColor: '#FF7800',
      },
    },
    MuiPickersClockNumber: {
      selected: {
        backgroundColor: '#FF7800',
      },
    },
    MuiPickersDay: {
      day: {
        color: '#777777',
      },
      selected: {
        backgroundColor: '#FF7800',
        '&:hover': {
          backgroundColor: '#FF7800',
        },
      },
      current: {
        color: '#777777',
      },
    },
    MuiPickersYear: {
      root: {
        color: '#777777',
        '&:hover': {
          color: '#FF7800',
        },
      },
      selected: {
        color: '#FF7800 !important',
        '&:hover': {
          color: '#FF7800',
        },
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#777777',
      },
    },
  },
})

@inject('internal')
@inject('translate')
@observer
export default class IssueCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingPage: true,
      loadingTable: true,
      locale: 'sk',
      dateFilterAnchorEl: null,
      selectDateFrom: null,
      selectDateTo: null,
      import: false,
    }
  }
  
  
  dropDownMenuItems = [
    {
      title: this.props.translate.i18n.GLOBAL.BUTTONS.DETAIL,
      action: 'issue-card',
    },
  ]
  
  componentDidMount() {
    this.props.internal.setRoute(this.props.history, this.props.location.pathname)
    this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.ISSUE_CARDS)
    
    const permissions = toJS(this.props.internal.user.data.permissions)
    if (permissions.issue_cards.export) {
      this.dropDownMenuItems.push({
        title: this.props.translate.i18n.MODULES.ISSUE_CARDS.EXPORT_HISTORY,
        action: 'issue-card-history-export',
      })
    }
    if (permissions.issue_cards.export) {
      this.dropDownMenuItems.push({
        title: this.props.translate.i18n.MODULES.ISSUE_CARDS.GENERATE_PDF,
        action: 'issue-card-export',
      })
    }
    
    this.loadIssueCards()
    
  }
  
  tableHeader = [
    {
      title: 'title',
      className: 'white-space-nowrap',
    },
    {
      title: 'last_entry_status',
    },
    {
      title: 'updated_at',
      className: 'white-space-nowrap',
      sortKey: 'updated_at',
    },
    {
      title: 'updated_by',
      className: 'white-space-nowrap',
    },
  ]
  
  tableBody = [
    'issue_card_title',
    'last_entry_status',
    'updated_at',
    'updated_by',
  ]
  
  tableReload = false
  
  apiCallCounter = 0
  
  loadIssueCards = async (size = 10, page = 0, searchterm = '', by = '', dir = 'asc') => {
    // if(this.tableReload) {
    //     this.setState({loadingTable: true})
    //     this.apiCallCounter++;
    // }
    
    const URLqueryString = this.props.history.location.search
    let queries = queryString.parse(URLqueryString)
    
    let params = {}
    let filters = {}
    
    params.filters = filters
    
    if (queries) {
      if (queries.page_number) {
        page = queries.page_number
        params.page = {
          number: page,
        }
      }
      
      if (queries.page_size) {
        size = queries.page_size
        params.page = {
          ...(params.page || {}),
          size: size,
        }
      }
      
      if (queries.by && queries.dir) {
        by = queries.by
        dir = queries.dir
        params.order = []
        params.order.push({
          by: by,
          dir: dir,
        })
      }
      
      // if(queries.by) {
      //     by = queries.by
      //     params.order[0] = {
      //                     by: by,
      //                 }
      // }
      
      // if(queries.dir) {
      //     dir = queries.dir
      //     params.order[0] = {
      //         dir: dir,
      //     }
      // }
      
      if (queries.searchterm) {
        searchterm = queries.searchterm
        params.searchterm = searchterm
      }
      
      // if (queries.customer_order_status_id) {
      //     filters.customer_order_status_id = Number(queries.customer_order_status_id)
      //     this.setState({
      //         customer_order_status_id: Number(queries.customer_order_status_id)
      //     })
      // }
      
      // if (queries.paid_at) {
      //     filters.paid_at = queries.paid_at
      //     this.setState({ paid_at: queries.paid_at })
      // }
      
      // if (queries.selectDateFrom && queries.selectDateTo) {
      //     filters.created_at = [queries.selectDateFrom, queries.selectDateTo]
      //     this.setState({ selectDateFrom: moment(queries.selectDateFrom), selectDateTo: moment(queries.selectDateTo) })
      // }
    }
    
    params.filters = filters
    
    let load_data = await api({
      method: 'get',
      url: 'issue-cards',
      authorization: this.props.internal.user.access_token,
      params: params,
      // params:{
      //     searchterm: searchterm,
      //     page:{
      //         number:page,
      //         size:size,
      //     },
      //     order: [
      //         {
      //             by: by,
      //             dir: dir
      //         }
      //     ]
      // }
    })
    
    if (load_data.success === true) {
      if (load_data.data) {
        this.props.internal.setDataForTable(load_data.data)
        this.setState({ loadingTable: false })
      }
    }
    this.setState({ loadingPage: false })
    
    if (this.tableReload) {
      this.apiCallCounter--
      if (this.apiCallCounter === 0) {
        this.setState({ loadingTable: false })
        this.tableReload = false
      }
    }
  }
  
  handleChangeRowsPerPage = size => {
    this.setState({
      loading: true,
    })
    this.addQueryToUrl('page_size', size)
  }
  
  handleChangePage = page => {
    this.setState({
      loading: true,
    })
    
    this.addQueryToUrl('page_number', page + 1)
  }
  
  handleSearch = debounce((searchTerm) => {
    if (searchTerm.length > 2) {
      this.tableReload = true
      this.addQueryToUrl('searchterm', searchTerm)
    } else {
      this.addQueryToUrl('searchterm', '')
    }
  }, 500)
  
  handleSort = (dir, orderBy) => {
    this.setState({
      loading: true,
    })
    this.addQueryToUrl('dir', dir, 'by', orderBy)
  }
  
  addQueryToUrl = (param, value, param2 = null, value2 = null, load = true) => {
    this.tableReload = true
    
    const URLqueryString = this.props.history.location.search
    let queries = queryString.parse(URLqueryString)
    queries[param] = value
    if (param2 && value2) {
      queries[param2] = value2
    }
    
    if (value === null) {
      delete queries[param]
    }
    
    if (value2 === null) {
      delete queries[param2]
    }
    
    let new_path = this.props.location.pathname
    
    new_path += '?'
    for (let key in queries) {
      if (key) {
        new_path += key + '=' + queries[key] + '&'
      }
    }
    new_path = new_path.slice(0, -1)
    
    this.props.internal.pushRoute(new_path)
    if (load) {
      this.loadIssueCards()
    }
  }
  
  toggleImport = (reload = false) => {
    this.setState({ import: ! this.state.import })
    if (reload) {
      this.loadIssueCards()
    }
  }
  
  render() {
    const permissions = toJS(this.props.internal.user.data.permissions)
    
    return this.state.loadingPage ? (
      <CircularProgress className={'circular-progress'}/>
    ) : (
      <MuiThemeProvider theme={theme}>
        {this.state.import ? (
          <Import
            open
            title={this.props.translate.i18n.MODULES.ISSUE_CARDS.IMPORT_DIALOG_TITLE}
            onClose={this.toggleImport}
          />
        ) : null}
        <div className={'shopsContainer customerOrderStatuses'}>
          <div className={'searchBoxFilters flex space-between mb-first-line'}>
            <Grid container>
              <Grid item xs={9}>
                <Search
                  placeholder={this.props.translate.i18n.MODULES.ISSUE_CARDS.SEARCH}
                  classes={'admin-search'}
                  onChange={this.handleSearch}
                  value={this.state.searchTerm}
                />
              </Grid>
              <Grid item xs={3}>
                <div style={{ textAlign: 'right' }}>
                  {permissions.issue_cards.import ? (
                    <CustomButton
                      mystyle={'btn-orange-bg border-radius-18 ml-auto'}
                      title={this.props.translate.i18n.MODULES.ISSUE_CARDS.IMPORT}
                      onClick={this.toggleImport}
                    >
                      <Icon path={mdiCloudUpload} size={1}/>
                    </CustomButton>
                  ) : null}
                </div>
              </Grid>
            </Grid>
          </div>
          
          {this.state.loadingTable ? (
            <CircularProgress className={'circular-progress'}/>
          ) : (
            // null
            <div className={'issueCardsTable'}>
              <CustomTable
                dropDownMenuItems={this.dropDownMenuItems}
                module={'/issue_cards'}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                handleChangePage={this.handleChangePage}
                handleSort={this.handleSort}
                header={this.tableHeader}
                body={this.tableBody}
              />
            </div>
          )}
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/IssueCards/IssueCards.jsx